/* eslint-disable no-unused-vars */
import { Typography } from "@mui/material";
import PCheck from "../../components/pos/PCheck";
import PSettingsCard from "../../components/pos/PSettingsCard.jsx";
import PText from "../../components/pos/PText";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export default function ProductSettings(props) {
  const { t } = useTranslation();
  const translate = t;
  const [liveValidation, setLiveValidation] = useState(false);

  const [itemCodeLen, setitemCodeLen] = useState("0");
  const [itemCodeLenError, setitemCodeLenError] = useState();

  const [
    enableDataUploadFeatureInPurchaseOrder,
    setEnableDataUploadFeatureInPurchaseOrder,
  ] = useState(false);

  useEffect(() => {
    if (liveValidation) validateitemCodeLen();
  }, [itemCodeLen]);

  const content = (
    <table width="100%">
      <tbody>
        <tr>
          <td>
            <Typography variant="body1">
              {translate("Item Code Length")}
            </Typography>
          </td>
          <td width={200}>
            <PText
              type={"number"}
              value={itemCodeLen}
              error={itemCodeLenError}
              onChange={(e) => setitemCodeLen(e.target.value)}
            ></PText>
          </td>
        </tr>
        <tr>
          <td width={200}>
            <PCheck
              onChange={(value) =>
                setEnableDataUploadFeatureInPurchaseOrder(value)
              }
              checked={enableDataUploadFeatureInPurchaseOrder}
              label={translate("Enable Excel Upload Feature in Purchase Order")}
            ></PCheck>
          </td>
        </tr>
      </tbody>
    </table>
  );

  function validate() {
    setLiveValidation(true);
    return validateitemCodeLen();
  }

  function validateitemCodeLen() {
    if (itemCodeLen) {
      let val = parseInt(itemCodeLen);
      if (val < 1) {
        setitemCodeLenError(
          translate("Item Code Length Should be Greater than Zero")
        );
        return false;
      } else if (val > 10) {
        setitemCodeLenError(
          translate("Item Code Length Should be Less than Ten")
        );
        return false;
      } else {
        setitemCodeLenError("");
        return true;
      }
    } else {
      setitemCodeLenError(translate("Item Code Length is required"));
      return false;
    }
  }

  function createPayload(payload) {
    payload["itemCodeLen"] = itemCodeLen;
    payload["enableDataUploadFeatureInPurchaseOrder"] =
      enableDataUploadFeatureInPurchaseOrder;
  }

  function populateObject(bean) {
    console.log("POPULATE");
    setitemCodeLen(bean.itemCodeLen);
    setEnableDataUploadFeatureInPurchaseOrder(
      bean.enableDataUploadFeatureInPurchaseOrder
    );
  }

  return (
    <PSettingsCard
      avatar="P"
      title={translate("Product Settings")}
      cardContent={content}
      onValidate={validate}
      createPayload={createPayload}
      populateObject={populateObject}
      messagHandler={props.messagHandler}
      settingKey="product"
    ></PSettingsCard>
  );
}
